//Get date
const getDate = () => {
    let weekDay = ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"];
    let months = ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"];
    
    let currentDate = new Date();
    let daysText = weekDay[currentDate.getDay()];
    let dayNumber = currentDate.getDate();
    let month = months[currentDate.getMonth()];
  
    return `${daysText} ${dayNumber} de ${month}`;
}

//get hour
const getHour = () => {
    let currentDate = new Date();
    let hours = currentDate.getHours();
    let minutes = currentDate.getMinutes();
    let seconds = currentDate.getSeconds();
    let period = (hours >= 12) ? "pm" : "am";
  
    // Convert hours
    if (hours > 12) {
      hours -= 12;
    } else if (hours === 0) {
      hours = 12;
    }
  
    // Add cero if its necesary
    hours = (hours < 10) ? "0" + hours : hours;
    minutes = (minutes < 10) ? "0" + minutes : minutes;
    seconds = (seconds < 10) ? "0" + seconds : seconds;
  
    return `${hours}:${minutes}:${seconds} ${period}`;
}

//Set hour date and categories
const DataParcial = ()=>{
    const headerContent = document.querySelector('#header-content');
    const triviaCategory = document.querySelector('#category-trivia');
    const triviaDay = document.querySelector('#day-trivia');
    const triviaHour = document.querySelector('#hour-trivia');
    const categorie = localStorage.getItem('categorie');
    //Render header and content
    categorie == 'Profesional' && headerContent.classList.add('profesional');
    categorie == 'Legendario' && headerContent.classList.add('legendario');
    headerContent.classList.add('header-trivia');
    triviaCategory.textContent = `Categoría ${categorie ? categorie : 'aficionado'}`;
    triviaDay.textContent = getDate();
    setInterval(()=>{
        triviaHour.textContent = `Hora col ${getHour()}`;
    },1000);
}

export { DataParcial, getDate }